<template>
  <div class="errors-container">
    <Typography variant="h-4"
      ><v-icon color="error" large class="pr-2 pb-1">mdi-alert-circle</v-icon>We couldn't add these
      people</Typography
    >
    <Typography variant="body-1" class="pt-10"
      ><v-icon color="black" class="pr-2">mdi-account-multiple</v-icon
      ><strong
        >{{ formatNumber(processedUserCount) }}
        {{ processedUserCount === 1 ? "person" : "people" }}</strong
      >
      {{ processedUserCount === 1 ? "was" : "were" }} added</Typography
    >
    <div class="py-8">
      <Typography variant="body-1" as="span" class="pa-4 errorLight"
        ><v-icon color="black" class="pr-2">mdi-account-multiple</v-icon
        ><strong
          >{{ formatNumber(fileErrors.length) }}
          {{ fileErrors.length === 1 ? "person" : "people" }}</strong
        >
        {{ fileErrors.length === 1 ? "needs a fix" : "need fixes" }}</Typography
      >
    </div>
    <div v-if="fileErrors.length > 0" class="pt-4 pb-10">
      <Typography variant="body-1">Fix the issues below and try again.</Typography>
      <div class="error-list-container pt-10">
        <v-data-table
          :items="fileErrors"
          :headers="headers"
          :hide-default-footer="fileErrors.length <= 10"
        >
          <template v-slot:[`item.person`]="{ item }">
            <Typography variant="body-2" class="word-break">{{ item.person }}</Typography>
          </template>
          <template v-slot:[`item.error`]="{ item }">
            <Typography variant="body-2" class="word-break">{{ item.error }}</Typography>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <Typography variant="body-2" class="word-break">{{ item.action }}</Typography>
          </template>
          <template v-slot:[`item.index`]="{ item }">
            <Typography variant="body-2" class="word-break">{{ item.index }}</Typography>
          </template>
        </v-data-table>
      </div>
    </div>
    <div class="d-flex justify-center">
      <Button @click="$emit('reset')">Fix & Try Again</Button>
      <Button @click="$emit('close')" outlined class="ml-4">Cancel</Button>
    </div>
    <CustomerServiceContact class="pt-10" />
  </div>
</template>

<script>
import Typography from "@/components/generic/Typography";
import Button from "@/components/generic/Button";
import CustomerServiceContact from "@/components/help/CustomerServiceContact";

import formatNumber from "@/mixins/formatNumber";
export default {
  name: "Errors",
  mixins: [formatNumber],
  components: {
    Typography,
    Button,
    CustomerServiceContact,
  },
  emits: ["close", "reset"],
  props: {
    processedUserCount: {
      type: Number,
    },
    fileErrors: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      headers: [
        { text: "Row #", value: "index", width: "100px" },
        { text: "Person", value: "person", width: "150px" },
        { text: "Issue", value: "error", width: "50%" },
        { text: "Action", value: "action", width: "50%" },
      ],
    };
  },
};
</script>

<style scoped>
.errors-container {
  /* display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2rem; */
  padding-top: 3rem;
}

.error-list-container ::v-deep .v-data-table tbody tr td {
  padding-top: 10px;
  padding-bottom: 10px;
}
</style>
